import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { PayPalButtons } from "@paypal/react-paypal-js";
import axios from 'axios';
import ModalTailwind from '../../components/ModalTailwind';

const SuscripcionPay = () => {
  const { user } = useAuth();
  const [telefono, setTelefono] = useState('');

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({ title: '', mensaje: '', isError: false, onConfirm: null, showConfirmButtons: false });
  const navigate = useNavigate();
  const [reloadOnClose, setReloadOnClose] = useState(false); // Flag para recargar al cerrar modal

  // Datos del AuthContext
  const userData = {
    id: user?.id,
    nombre: user?.nombre,
    apellidos: user?.apellidos,
    correo: user?.correo,
    rol: user?.rol,
    account_type: user?.account_type,
  };

  // Obtener teléfono desde la BD
  useEffect(() => {
    const fetchDatosPersonales = async () => {
      if (user?.id) {
        try {
          const res = await axios.get(`https://www.fancyplus.digital/api/users/datos-personales/${user.id}`);
          setTelefono(res.data.telefono); // debe coincidir con tu campo de la BD
        } catch (error) {
          console.error('Error al obtener datos personales:', error);
        }
      }
    };
    fetchDatosPersonales();
  }, [user]);

  // Función para abrir modal simple
  const abrirModal = ({ title, mensaje, isError = false }) => {
    setModalInfo({ title, mensaje, isError, onConfirm: null, showConfirmButtons: false });
    setShowModal(true);
  };

  // Forzar recarga completa (cache-buster) cuando se cierra el modal
// Función para cerrar modal y redirigir
const handleModalClose = () => {
  setShowModal(false);
  if (reloadOnClose) {
    window.location.href = "/PerfilUser"; // Redirige y recarga todo
  }
};

  // Función para abrir modal de confirmación para pago simulado
  const abrirModalConfirmacion = () => {
    setModalInfo({
      title: "Confirmar pago simulado",
      mensaje: (
        <>
          <p className="mb-4">Vas a pagar con <strong>Pago Simulado</strong> la suscripción <span className="italic font-semibold">FancyPlus +Premium</span>.</p>
          <p className="mb-2 text-lg font-bold">$80.00 MXN</p>
          <p className="text-sm text-gray-600">¿Quieres confirmar el pago?</p>
        </>
      ),
      isError: false,
      showConfirmButtons: true,
      onConfirm: async () => {
        try {
          await axios.post("https://www.fancyplus.digital/api/users/simular-pago", {
            iduser: user.id
          });
          setShowModal(false);
          abrirModal({
            title: "¡Pago simulado exitoso!",
            mensaje: "¡Gracias por suscribirte a FancyPlus +Premium! Ahora tienes acceso completo a todas las funcionalidades exclusivas. ¡Disfrútalo!",
          });
          setReloadOnClose(true);
        } catch (error) {
          console.error("Error en pago simulado:", error);
          setShowModal(false);
          abrirModal({
            title: "Error",
            mensaje: "Error al simular el pago. Por favor intenta de nuevo.",
            isError: true,
          });
        }
      }
    });
    setShowModal(true);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-2xl flex flex-col md:flex-row overflow-hidden">
        {/* Sección izquierda */}
        <div className="w-full md:w-1/2 bg-purple-800 text-white p-8">
          <h2 className="text-3xl italic font-bold mb-6">
            FancyPlus <span className="text-yellow-300">+Premium</span>
          </h2>
          <ul className="space-y-4 text-lg">
            <li className="flex items-center gap-3">
              <FontAwesomeIcon icon={faCheck} className="text-green-300" />
              Acceso completo al historial de signos vitales
            </li>
            <li className="flex items-center gap-3">
              <FontAwesomeIcon icon={faCheck} className="text-green-300" />
              Visualización en tiempo real de los datos
            </li>
            <li className="flex items-center gap-3">
              <FontAwesomeIcon icon={faCheck} className="text-green-300" />
              Reportes semanales descargables
            </li>
            <li className="flex items-center gap-3">
              <FontAwesomeIcon icon={faCheck} className="text-green-300" />
              Alertas avanzadas personalizadas
            </li>
          </ul>
        </div>

        {/* Sección derecha */}
        <div className="w-full md:w-1/2 p-8 flex flex-col justify-between">
          <div>
            <h3 className="text-2xl font-semibold mb-4">Tus datos</h3>
            <div className="grid grid-cols-1 gap-4 text-gray-700 text-sm sm:text-base">
              <div className="flex items-center gap-2">
                <span><strong>Nombre:</strong> {userData.nombre} {userData.apellidos}</span>
              </div>
              <div className="flex items-center gap-2">
                <FontAwesomeIcon icon={faEnvelope} />
                <span><strong>Correo:</strong> {userData.correo}</span>
              </div>
              <div className="flex items-center gap-2">
                <FontAwesomeIcon icon={faPhone} />
                <span><strong>Teléfono:</strong> {telefono}</span>
              </div>
            </div>

            {/* Ticket de pago */}
            <div className="mt-8 p-4 border border-gray-300 rounded-lg shadow-sm bg-gray-50">
              <h4 className="text-xl font-medium mb-2">Suscripción Mensual</h4>
              <div className="text-gray-800">
                FancyPlus <span className="font-semibold italic text-yellow-600">+Premium</span>
              </div>
              <div className="text-2xl font-bold mt-2">$80.00 MXN</div>
            </div>
          </div>

          {/* Botones de pago */}
          <div className="mt-6 space-y-3">
            {!showModal && (
            <PayPalButtons
              style={{ layout: "vertical", color: "gold", shape: "pill", label: "paypal" }}
              createOrder={(data, actions) => {
                return actions.order.create({
                  purchase_units: [{
                    amount: {
                      value: "80.00", // monto en MXN
                      currency_code: "MXN"
                    }
                  }]
                });
              }}
              onApprove={async (data, actions) => {
                try {
                  const details = await actions.order.capture();
                  const transactionId = details.id;
                  const monto = details.purchase_units[0].amount.value;

                  // Enviar a backend
                  await axios.post("https://www.fancyplus.digital/api/users/paypal/confirmar-pago", {
                    iduser: user.id,
                    transactionId,
                    monto,
                    moneda: "MXN"
                  });

                  abrirModal({
                    title: "¡Pago exitoso!",
                    mensaje: "¡Gracias por suscribirte a FancyPlus +Premium! Ahora tienes acceso completo a todas las funcionalidades exclusivas. ¡Disfrútalo!",
                  });
                  setReloadOnClose(true);
                } catch (error) {
                  console.error("Error registrando el pago en backend", error);
                  abrirModal({
                    title: "Error",
                    mensaje: "Error al procesar el pago. Por favor intenta nuevamente.",
                    isError: true,
                  });
                }
              }}
              onCancel={() => {
                abrirModal({
                  title: "Pago cancelado",
                  mensaje: "El pago fue cancelado. Si deseas, puedes intentarlo nuevamente.",
                  isError: true,
                });
              }}
              onError={(err) => {
                console.error("Error en PayPal:", err);
                abrirModal({
                  title: "Error",
                  mensaje: "Ocurrió un error al procesar el pago con PayPal. Intenta más tarde.",
                  isError: true,
                });
              }}
            />
            )}

            <button
              onClick={abrirModalConfirmacion}
              className="w-full bg-indigo-600 text-white font-semibold py-2 px-6 rounded-full hover:bg-indigo-500 transition duration-300"
            >
              Simular Pago
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}
      <ModalTailwind
        show={showModal}
        onClose={handleModalClose} // Aquí también se llama esta función
        title={modalInfo.title}
      >
        <div className={modalInfo.isError ? "text-red-600" : "text-gray-700"}>
          {modalInfo.mensaje}
        </div>

        {modalInfo.showConfirmButtons ? (
          <div className="mt-6 flex justify-end gap-4">
            <button
              className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              onClick={() => setShowModal(false)}
            >
              Cancelar
            </button>
            <button
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              onClick={() => {
                if (modalInfo.onConfirm) modalInfo.onConfirm();
              }}
            >
              Confirmar pago
            </button>
          </div>
        ) : (
          <div className="mt-6 flex justify-end">
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={handleModalClose}
            >
              Aceptar
            </button>
          </div>
        )}
      </ModalTailwind>
    </div>
  );
};

export default SuscripcionPay;
